module.exports = __webpack_public_path__ + "static/20240618_Announcement_Russia-5eafc8dbd95cf293141ed75f41f6c5cf.pdf";